import { useContext } from "react"
import Slider from "react-slick"
import { AppContext } from "../App"
import { CDN_URL, formatMoney } from "../Helpers"

export default function MarketplaceSlider({ items }) {

  const appContext = useContext(AppContext);

  const settings = {
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: items.length > 1,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
  };

  function view(item) {
    appContext.navTo({
      item: 'view',
      subItem: `view-${item.type.toLowerCase()}`,
      extraItem: item.uuid,
    })
  }

  function getTitleClass(title) {
    const titleLength = String(title || '').trim().length;

    if (titleLength > 70) {
      return 'long';
    } else if (titleLength > 45) {
      return 'medium';
    }

    return '';
  }

  if (items.length === 0) {
    return (
      <div className="marketplace-slider-empty d-flex align-items-center">
        <div className="container">
          <span className="marketplace-eyebrow">MIKA KENYATA</span>
          <h1>Books, videos, journals and stories in one place.</h1>
          <p>Fresh content will appear here as soon as it is published.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="marketplace-slider">
      <Slider {...settings}>
        {
          items.map((item) => {
            return (
              <div key={`${item.type}-${item.uuid}`}>
                <div className="marketplace-slide">
                  <img src={CDN_URL + item.coverPhoto} alt={item.title} />
                  <div className="marketplace-slide-overlay"></div>

                  <div className="marketplace-slide-content container">
                    <span className="marketplace-eyebrow">Recent {item.type}</span>
                    <h1 className={getTitleClass(item.title)} title={item.title}>{item.title}</h1>
                    <h6>TZS {formatMoney(item.price)}</h6>
                    <button
                      className="btn btn-primary btn-rounded mt-3"
                      onClick={() => view(item)}
                    >
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            )
          })
        }
      </Slider>
    </div>
  )
}
